export function isEmpty(target: { length: number } | null | undefined) {
  return target && target.length > 0 ? false : true;
}

